import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';

import { ViewWillEnter } from '@ionic/angular';

import { ContactModalPage, ContactModalPageIdentifier } from '../../modals/contact-modal/contact-modal.page';

import { ContactType } from '../../core/enums/contact-type.enum';

import { AnalyticsService } from '../../core/services/analytics.service';
import { ContactService } from '../../core/services/contact.service';
import { ModalService } from '../../core/services/modal.service';
import { OverlayService } from '../../core/services/overlay.service';
import { SettingsService } from '../../core/services/settings.service';

import { AnalyticsConfig, TOKEN_ANALYTICS_CONFIG } from '../../core/config/analytics.config';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContactPage implements OnInit, ViewWillEnter {
  public isWhatsAppChatEnabled: boolean;

  constructor(
    private modalService: ModalService,
    private overlayService: OverlayService,
    private contactService: ContactService,
    private settingsService: SettingsService,
    private analyticsService: AnalyticsService,
    @Inject(TOKEN_ANALYTICS_CONFIG) private analyticsConfig: AnalyticsConfig,
  ) {}

  ngOnInit(): void {
    this.isWhatsAppChatEnabled = this.settingsService.isWhatsAppChatEnabled();
  }

  ionViewWillEnter() {
    this.trackPageView();
  }

  public onSendFeedback(): void {
    void this.modalService.showModal({
      component: ContactModalPage,
      id: ContactModalPageIdentifier,
      componentProps: { contactType: ContactType.Contact },
    });
  }

  public onCallUs(): void {
    void this.overlayService.showLoading().then(() => this.contactService.callBilbayt().then(() => this.overlayService.hideLoading()));
  }

  public onEmailUs(): void {
    void this.overlayService.showLoading().then(() => this.contactService.emailBilbayt().then(() => this.overlayService.hideLoading()));
  }

  public onTextUs(): void {
    this.contactService.startChatWithBilbayt();
  }

  private trackPageView(): void {
    void this.analyticsService.trackView({ name: this.analyticsConfig.pageName.contactPage });
  }
}
